<template>
      <div class="ready-to-launch">
        <!-- <h2>Ready to Launch?</h2> -->
      <ul class="nav nav-tabs" style="margin-bottom: 25px;">
      <li class="active"><a data-toggle="tab" href="#campaign-overview">Campaign Overview</a></li>
      <li><a data-toggle="tab" href="#location-overview">Location Overview</a></li>
      <li><a data-toggle="tab" href="#audience-overview">Audience Overview</a></li>
      <li v-if="!isMixCampaign"><a data-toggle="tab" href="#activity">Activity</a></li>
      <li v-if="isMixCampaign && hasWatchActivity"><a data-toggle="tab" href="#mix-video">Video</a></li>
      <li v-if="isMixCampaign && hasProductPhotos"><a data-toggle="tab" href="#mix-product-photos">Product Photos</a></li>
      <li v-if="!isMixCampaign || hasSurveyActivity"><a data-toggle="tab" href="#survey-insight">{{ isMixCampaign ? 'Survey' : 'Survey Insight' }}</a></li>
      <li><a data-toggle="tab" href="#incentives">Incentives</a></li>
      </ul>
        <div class="row">
          <div class="col-md-8">
            <div class="tab-content">
            <div id="campaign-overview" class="campaign-overview tab-pane fade in active">
              <h3>Campaign Overview</h3>
              <div class="campaign-overview-list">
                <div class="row">
                  <div class="col-md-12">
                    <div class="row">
                      <div class="col-md-6">
                        <h4>Campaign Name</h4>
                        <h6>{{ getCampaignDetail.campaign_name }}</h6>
                        <h4>Num of Activities</h4>
                        <h6>{{ getCampaignDetail.total_activity_count }}</h6>
                        <!-- <h4>Incentive Type</h4>
                        <h6>{{ getCampaignDetail.incentive_type }}</h6> -->
                        <h4>Start Date</h4>
                        <h6>{{ getCampaignDetail.start_date }}</h6>
                        <h4>Unlock Code</h4>
                        <h6>{{ getCampaignDetail.unlock_code }}</h6>
                        <h4>Buy Me Activity</h4>
                        <h6>Not available for freemium</h6>
                        <h4>Budget</h4>
                        <h6>{{ getCampaignDetail.campaign_budget }}</h6>
                      </div>
                      <div class="col-md-6">
                        <h4>Location Type</h4>
                        <h6 v-if="getCampaignDetail.geo_location_type == 'any-user-location'">Anywhere (Audience's Choice)</h6>
                        <h6 v-if="getCampaignDetail.geo_location_type == 'any-physical-location'">Custom Location (Flexible Address)</h6>
                        <h4>Single User Limit</h4>
                        <h6>{{ getCampaignDetail.single_user_limit }}</h6>
                        <h4>End Date</h4>
                        <h6 style="min-height: 15.9px;">{{ getCampaignDetail.end_date }}</h6>
                        <h4>Plan</h4>
                        <h6>{{ getCampaignDetail.package }}</h6>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div id="activity" class="campaign-overview tab-pane fade" v-if="!isMixCampaign && getCampaignDetail && getCampaignDetail.id">
              <h3 style="margin-top: 5px; margin-bottom: 20px;">Activity Details</h3>
              <div v-if="getCampaignDetail.geo_location_type == 'any-user-location'">
                  <h4> {{ media.title }} </h4>
                  <iframe width="100%" height="300px" :src="'https://www.youtube.com/embed/'+videoId" title="YouTube video player"
                  frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                  referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
                  <p style="text-align: left; margin-top: 10px; font-size: 20px; margin-bottom: 15px;">{{ media.brand_intro }}</p>
                  <p style="text-align: left; margin-bottom: 15px;">{{ media.description }}</p>
                  <div v-if="media.have_app_links == '1'">
                      <h5 style="font-size: 17px; color: #000;">App Name: {{ media.app_name }}</h5>
                      <h6 style="font-size: 15px;" v-if="media.android_app_link">Android App Link: {{ media.android_app_link }}</h6>
                      <h6 style="font-size: 15px;" v-if="media.ios_app_link">IOS App Link: {{ media.ios_app_link }}</h6>
                  </div>
                  <div v-if="media.have_web_links == '1'">
                    <h5>Website Name: {{ media.app_name }}</h5>
                    <h6 style="font-size: 16px; color: #000; margin-top: 15px;" v-if="media.android_app_link">Website Link: {{ media.website_url }}</h6>
                  </div>
                  <div class="row">
                    <div class="col-md-3" v-for="mediaImg in media.media_images" :key="mediaImg.image">
                      <div class="mediaBox" style="margin-top: 20px;">
                        <img :src="mediaImg.image" style="max-width: 100%;" />
                        <h4>{{ mediaImg.description }}</h4>
                      </div>
                    </div>
                  </div>
              </div>
              <div v-else>
                <h4>Guide Page: {{ getProductDetail.name }}</h4>
                <div class="row">
                  <div class="col-md-3" v-for="getImag in getImages" style="margin-top: 15px;" :key="getImag.img">
                    <img :src="getImag.img" style="max-width: 100%;">
                    <h5>{{ getImag.description }}</h5>
                  </div>
                </div>
                <h6 style="font-size: 17px;color: #000;margin-bottom: 5px; font-weight: 500;">Description</h6>
                <p>{{ getProductDetail.description }}</p>
                <h6 style="font-size: 17px;color: #000;font-weight: 500;">Visual Prompt</h6>
                <div class="row">
                  <div class="col-md-3" v-for="task in getTasks" :key="task.name">
                    <div class="taskBox" style="margin-top: 15px;">
                      <img :src="task.img" style="max-width: 100%;">
                      <h5>{{ task.name }}</h5>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Mix: Video tab -->
            <div id="mix-video" class="campaign-overview tab-pane fade" v-if="isMixCampaign && hasWatchActivity">
              <h3 style="margin-top: 5px; margin-bottom: 20px;">{{ watchActivity.activity_label || 'Video' }}</h3>
              <iframe
                v-if="watchVideoId"
                width="100%"
                height="300px"
                :src="'https://www.youtube.com/embed/'+watchVideoId"
                title="YouTube video player"
                frameborder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                referrerpolicy="strict-origin-when-cross-origin"
                allowfullscreen
              ></iframe>
              <p v-else style="text-align: left;">No video link available</p>
              <h6 style="font-size: 17px;color: #000;margin: 15px 0 5px; font-weight: 500;">Description</h6>
              <p style="text-align: left;">{{ watchActivity.description || (watchActivity.link && watchActivity.link.description) || '' }}</p>
              <h6 v-if="watchActivity.link && watchActivity.link.website_link" style="font-size: 15px; color: #000; margin-top: 10px;">
                Link: <a :href="watchActivity.link.website_link" target="_blank">{{ watchActivity.link.website_link }}</a>
              </h6>
            </div>

            <!-- Mix: Product Photos tab -->
            <div id="mix-product-photos" class="campaign-overview tab-pane fade" v-if="isMixCampaign && hasProductPhotos">
              <h3 style="margin-top: 5px; margin-bottom: 20px;">Product Photos</h3>
              <div v-if="productActivity && productActivity.products && productActivity.products.length">
                <div v-for="(product, pIndex) in productActivity.products" :key="product.product_id || pIndex" style="margin-bottom: 25px;">
                  <h4>{{ product.name || ('Product ' + (pIndex + 1)) }}</h4>
                  <div class="row">
                    <div class="col-md-3" v-if="product.img">
                      <img :src="product.img" style="max-width: 100%;">
                      <h5>Product</h5>
                    </div>
                  </div>
                  <p v-if="product.description" style="text-align: left; margin-top: 10px;">{{ product.description }}</p>
                  <h6 style="font-size: 17px;color: #000;font-weight: 500; margin-top: 15px;">Visual Prompt</h6>
                  <div class="row">
                    <div class="col-md-3" v-for="task in (product.tasks || [])" :key="'p-task-' + task.id">
                      <div class="taskBox" style="margin-top: 15px;">
                        <img :src="task.img" style="max-width: 100%;">
                        <h5>{{ task.name }}</h5>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div v-if="photoActivity && mixPhotoTasks.length">
                <h4>{{ photoActivity.activity_label || 'Photo Activity' }}</h4>
                <p v-if="photoActivity.description" style="text-align: left;">{{ photoActivity.description }}</p>
                <h6 style="font-size: 17px;color: #000;font-weight: 500; margin-top: 15px;">Visual Prompt</h6>
                <div class="row">
                  <div class="col-md-3" v-for="task in mixPhotoTasks" :key="'photo-task-' + task.id">
                    <div class="taskBox" style="margin-top: 15px;">
                      <img :src="task.img" style="max-width: 100%;">
                      <h5>{{ task.name }}</h5>
                    </div>
                  </div>
                </div>
              </div>
              <div v-if="productActivity && (!productActivity.products || !productActivity.products.length) && mixProductTasks.length">
                <h6 style="font-size: 17px;color: #000;font-weight: 500;">Visual Prompt</h6>
                <div class="row">
                  <div class="col-md-3" v-for="task in mixProductTasks" :key="'mix-task-' + task.id">
                    <div class="taskBox" style="margin-top: 15px;">
                      <img :src="task.img" style="max-width: 100%;">
                      <h5>{{ task.name }}</h5>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div id="location-overview" class="campaign-overview tab-pane fade" v-if="getCampaignDetail && getCampaignDetail.id">
              <h3>Location Overview</h3>
              <div class="campaign-overview-list">
                <div class="row">
                  <div class="col-md-12">
                    <div class="row">
                      <div class="col-md-6">
                        <h4>Single User Limit</h4>
                        <h6>{{ getCampaignDetail.single_user_limit }}</h6>
                        <h4># of Countries</h4>
                        <h6>1</h6>
                        <h4>Launch Areas</h4>
                        <ChartTemp :codes="getSelStates" :retailerImage="getStoreDetail.img"/>
                      </div>
                      <div class="col-md-6">
                        <h4>Total Activity Count</h4>
                        <h6>{{ getCampaignDetail.total_activity_count }}</h6>
                        <h4># of States</h4>
                        <h6>{{ getAudienceCount.StateCount }}</h6>
                        <h4 v-if="getCampaignDetail.geo_location_type == 'any-physical-location'">Location</h4>
                        <img :src="getStoreDetail.img" style="max-width: 50%;" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div id="audience-overview" class="campaign-overview tab-pane fade" v-if="getCampaignDetail && getCampaignDetail.id">
              <h3>Audience Overview</h3>
              <div class="campaign-overview-list">
                <div class="row">
                  <div class="col-md-12">
                    <h6 style="margin-bottom: 3px; color: blue; margin-top: 0px; font-size: 15px;" v-if="getCampaignDetail.unlock_code == ''"><b style="color: #000;">Deep Link:</b> https://api.pickl.pro/pickl/{{ getCampaignDetail.id }}</h6>
                    <h6 style="margin-bottom: 3px; color: blue; margin-top: 0px; font-size: 15px;" v-else><b style="color: #000;">Deep Link:</b> https://api.pickl.pro/pickl/unlock/{{ getCampaignDetail.unlock_code }}</h6>
                    <div class="row">
                      <div class="col-md-6">
                        <h4># of Audiences</h4>
                        <h6>{{ getAudienceCount.AudienceCount }}</h6>
                        <h4># of Phone Numbers</h4>
                        <h6>{{ getAudienceCount.AudienceCount }}</h6>
                        <div style="clear: both;"></div>
                        <div style="position: relative;">
                        <label class="switch" style="z-index: 9; top: 0px;"><input type="checkbox" checked="" value="1"><span class="slider round"></span></label>
                        <label style="margin-left: 0px;color: #000; font-weight: 500;">Engage PICKL's Audience</label>
                        </div>
                      </div>
                      <div class="col-md-6">
                        <h4># of Emails</h4>
                        <h6>{{ getAudienceCount.AudienceCount }}</h6>
                        <!-- <h4># of Locations</h4>
                        <h6></h6> -->
                      </div>
                      <div class="col-md-12" v-if="getAudienceCount.AudienceCount">
                        <h4>Audiences List Uploaded</h4>
                        <div class="upload_zip">
                          <img src="/img/zip_up.png" class="zip_up">
                          <a :href="getAudienceCount.audience_file_name" download>Download </a>
                          <!-- <img src="/img/check.png" class="action"> -->
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div id="survey-insight" class="campaign-overview tab-pane fade" v-if="getCampaignDetail && getCampaignDetail.id && (!isMixCampaign || hasSurveyActivity)">
              <h3>{{ isMixCampaign ? 'Survey' : 'Survey Insight' }}</h3>
              <div class="campaign-overview-list">
                <div v-if="isMixCampaign && surveyActivity && surveyActivity.survey" style="margin-bottom: 20px;">
                  <h4>{{ surveyActivity.survey.title || surveyActivity.activity_label }}</h4>
                  <h6 v-if="surveyActivity.survey.type">Type: {{ surveyActivity.survey.type }}</h6>
                  <h6 v-if="surveyActivity.survey.questions_count != null">Questions: {{ surveyActivity.survey.questions_count }}</h6>
                  <p v-if="surveyActivity.description" style="text-align: left;">{{ surveyActivity.description }}</p>
                </div>
                <div class="row" v-if="surveyQuestionsList.length">
                  <div class="col-md-6" v-for="(question, qIndex) in surveyQuestionsList" :key="question.id || qIndex">
                    <h5 style="color: #000; font-size: 18px;">
                      {{ question.question || question.question_text || question.title || ('Question ' + (qIndex + 1)) }}
                      <span v-if="question.question_type || question.type" style="font-size: 14px;">
                        ({{ question.question_type || question.type }})
                      </span>
                    </h5>
                    <ul style="padding-left: 18px;" v-if="getSurveyAnswers(question).length">
                      <li v-for="(ans, aIndex) in getSurveyAnswers(question)" :key="ans.id || aIndex">
                        {{ ans.answer || ans.option || ans.text || ans }}
                      </li>
                    </ul>
                  </div>
                </div>
                <p v-else-if="isMixCampaign && hasSurveyActivity" style="text-align: left;">
                  Survey activity is configured for this campaign.
                </p>
              </div>
            </div>
            <div id="incentives" class="campaign-overview tab-pane fade" v-if="getCampaignDetail && getCampaignDetail.id">
              <h3>Incentives</h3>
              <div class="campaign-overview-list">
                <h4>{{ getCampaignDetail.coupon }}</h4>
                <h6 style="margin-bottom: 10px; color: blue; margin-top: 1px;">{{ getCampaignDetail.link }}</h6>
                <p>{{ getCampaignDetail.description }}</p>
                <img :src="getCampaignDetail.coupon_image" style="max-width: 50%;">
              </div>
            </div>
            </div>
          </div>
        <div class="col-md-4">

          <div :class="['preview NewPrevAct', { 'scrolled-fix': isScrolled }]" v-if="showProductPreview">
          <div class="store_brand">
            <img :src="getStoreDetail.img" class="left_brand" />
            <h6>{{ brandInfo.name }}</h6>
            <img :src="brandInfo.logo" class="right_brand" />
          </div>
          <div class="mapBox">
              <h5>"{{ getStoreDetail.name }}"</h5>
              <h6>Category: {{ previewProductDetail.name }}</h6>
              <ChartTemp :codes="getSelStates" :retailerImage="getStoreDetail.img"/>
          </div>
          <div class="brand_intro">
            <div class="brand_desc">
              <div class="brand_header" style="float: left;">
                <img :src="previewProductDetail.img" />
                <h6 style="text-align: left;color: #000; font-size: 15px;font-weight: 500;">{{ previewProductDetail.name }}</h6>
                <p style="text-align: left;">{{ previewProductDetail.description }}</p>
              </div>
              <p style="font-weight: 500; font-size: 14px;color: #000;text-align: left; float: left;width: 100%; margin-bottom: 7px;">{{ mixTasks.length ? 'Activities' : 'Image Requirements' }}</p>
              <ul style="max-height: 210px; overflow: hidden;padding-left: 6px; list-style: none;">
                <li v-for="(task, index) in previewTasks" :key="task.id || index" style="font-size: 14px;margin-bottom: 6px;">{{ getTaskDisplayName(task) }}</li>
              </ul>
            </div>
          </div>
        </div>

          <!-- <div class="preview" v-if="getCampaignDetail.geo_location_type == 'any-physical-location'">
            <div class="brand_head">
              <img src="/img/Arrow_2.png" />
              {{ getStoreDetail.brandName }}<br />{{ getStoreDetail.name }}
            </div>
            <h6></h6>
            <div class="store_brand">
              <img :src="getStoreDetail.img" class="left_brand" style="width:35px;" />
              <h6>Do it at any location</h6>
              <img :src="getStoreDetail.brandImg" class="right_brand" />
            </div>
            <div class="brand_intro">
              <div class="brand_desc">
                <div class="brand_header">
                  <img :src="getProductDetail.img" />
                  <h6 style="text-align: left;">{{ getProductDetail.name }}</h6>
                  <p class="special_notes">Special Notes</p>
                </div>
                <ul style="max-height: 130px; overflow: hidden; padding-left: 0; margin-top: 15px;">
                  <li v-for="task in getTasks" :key="task.name">{{ task.name }}</li>
                </ul>
                <img src="/img/start_pickl.png" class="start_pickl" />
              </div>
            </div>
            <img src="/img/phone_bottom.png" class="task_bar" />
          </div> -->
          <div :class="['preview cr_page newPrev', { 'scrolled-fix': isScrolled }]" v-else-if="showVideoPreview">
            <div class="logoHeadBox">
              <div class="newPrevLogo"><img :src="brandInfo.logo" style="max-width: 100%; border-radius: 50%;" /></div>
              <div class="newPrevHead"> {{ brandInfo.name }} </div>
            </div>
            <div class="yourVideo">
              <h5 v-if="!previewVideoId">Your Video</h5>
              <span v-else><iframe width="100%"
                  height="120px"
                  :src="'https://www.youtube.com/embed/'+previewVideoId"
                  title="YouTube video player"
                  frameborder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                  referrerpolicy="strict-origin-when-cross-origin"
                  allowfullscreen
                ></iframe
              ></span>
            </div>
            <div class="mediaDesc">
                <h4>Description</h4>
                <p style="text-align: left;">{{ previewMediaDescription }}</p>
            </div>
            <div class="mixTaskList" v-if="mixTasks.length">
              <h4>Activities</h4>
              <ul>
                <li v-for="(activity, index) in mixTasks" :key="activity.id || index">{{ getTaskDisplayName(activity) }}</li>
              </ul>
            </div>
          </div>

          <!-- <div :class="['preview cr_page', { 'scrolled-fix': isScrolled }]" v-else>
            <div class="brand_head">
              <img src="/img/Arrow_2.png" />
              {{ getStoreDetail.brandName }}
            </div>
            <div class="media_name">
              {{ media.title }}
            </div>
            <div class="your_video">
              <span><iframe width="100%" height="120px" :src="'https://www.youtube.com/embed/'+videoId" title="YouTube video player"
                  frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                  referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe></span>
            </div>
            <div class="brand_intro" style="top: 266px !important">
              <div class="brand_desc">
                <div class="brand_header">
                  <img :src="brandInfo.logo" />
                  <h6>{{ brandInfo.name }}</h6>
                  <p>Introduction</p>
                </div>
                <p style="font-size: 13px; padding: 12px; text-align: left;">{{ media.description }}</p>
              </div>
            </div>
            <img src="/img/phone_bottom.png" class="task_bar" />
          </div> -->
          </div>
        </div>

      </div>
</template>

<script>
import ChartTemp from '@/components/common/ChartDiv.vue'
import router from '@/router'
export default {
  name: 'AadvancedReview',
  components: {
    ChartTemp
  },
  data () {
    return {
      getStoreDetail: {},
      getProductDetail: {},
      getCampaignDetail: {},
      getAudienceCount: {},
      getSelStates: {},
      media: {},
      videoId: '',
      getTasks: [],
      getImages: [],
      getSurveyQuestion: [],
      mixTasks: [],
      productActivity: null,
      photoActivity: null,
      surveyActivity: null,
      mixProductDetail: null,
      watchActivity: null,
      watchVideoId: '',
      brandInfo: {
        name: '',
        logo: ''
      },
      isScrolled: false
    }
  },
  computed: {
    isMixCampaign () {
      return !!(this.mixTasks && this.mixTasks.length)
    },
    hasWatchActivity () {
      return !!this.watchActivity
    },
    hasProductActivity () {
      return !!this.productActivity
    },
    hasPhotoActivity () {
      return !!this.photoActivity
    },
    hasSurveyActivity () {
      return !!this.surveyActivity
    },
    hasProductPhotos () {
      return this.hasProductActivity || this.hasPhotoActivity
    },
    surveyQuestionsList () {
      if (this.isMixCampaign && this.surveyActivity) {
        if (Array.isArray(this.surveyActivity.questions) && this.surveyActivity.questions.length) {
          return this.surveyActivity.questions
        }
        if (this.surveyActivity.survey && Array.isArray(this.surveyActivity.survey.questions)) {
          return this.surveyActivity.survey.questions
        }
      }
      return this.getSurveyQuestion || []
    },
    mixProductTasks () {
      if (!this.productActivity) return []
      if (Array.isArray(this.productActivity.tasks) && this.productActivity.tasks.length) {
        return this.productActivity.tasks
      }
      const products = this.productActivity.products || []
      return products.reduce((all, product) => {
        return all.concat(product.tasks || [])
      }, [])
    },
    mixPhotoTasks () {
      if (!this.photoActivity || !Array.isArray(this.photoActivity.tasks)) return []
      return this.photoActivity.tasks
    },
    showProductPreview () {
      if (this.isMixCampaign) {
        // Mix: no Watch/video → show map (product) preview
        return !this.hasWatchActivity
      }
      return this.getCampaignDetail.geo_location_type === 'any-physical-location'
    },
    showVideoPreview () {
      if (this.isMixCampaign) {
        // Mix: Watch/video → show youtube preview
        return this.hasWatchActivity
      }
      return this.getCampaignDetail.geo_location_type !== 'any-physical-location'
    },
    previewProductDetail () {
      if (this.mixProductDetail && (this.mixProductDetail.name || this.mixProductDetail.img)) {
        return this.mixProductDetail
      }
      return this.getProductDetail || {}
    },
    previewTasks () {
      if (this.mixTasks && this.mixTasks.length) {
        return this.mixTasks
      }
      return this.getTasks || []
    },
    previewVideoId () {
      return this.watchVideoId || this.videoId || ''
    },
    previewMediaDescription () {
      if (this.watchActivity) {
        return this.watchActivity.description ||
          (this.watchActivity.link && this.watchActivity.link.description) ||
          ''
      }
      return this.media.description || ''
    }
  },
  mounted () {
    // this.getMedia()
    this.getStoreDetails()
    this.getCampaignView()
    this.getAudienceOverviewDetails()
    this.getProductTaskDetails()
    this.getMixCampaignActivityDetails()
    this.getStates()
    this.getSurveyInsight()
    window.addEventListener('scroll', this.handleScroll)
  },
  beforeUnmount () {
    window.removeEventListener('scroll', this.handleScroll)
  },
  methods: {
    handleScroll () {
      this.isScrolled = window.scrollY >= 300
    },
    getStoreDetails () {
      this.loadingStaff = true
      this.$http.get('plg/campaign-setting-store-detail/' + this.$route.params.CampaignId)
        .then((response) => {
          console.log(response.data)
          this.getStoreDetail = response.data
        }, (error) => {
          console.log(error)
        }).catch((error) => {
          this.$notify(
            { type: 'error', text: error.message }
          )
        })
    },
    getAudienceOverviewDetails () {
      this.$http.get('plg/get-audience-pickl-details/' + this.$route.params.CampaignId)
        .then((response) => {
          console.log(response.data)
          this.getAudienceCount = response.data
        }, (error) => {
          console.log(error)
        }).catch((error) => {
          this.$notify(
            { type: 'error', text: error.message }
          )
        })
    },
    getSurveyInsight () {
      this.$http.get('plg/survey-details/' + this.$route.params.CampaignId)
        .then((response) => {
          console.log(response.data)
          this.getSurveyQuestion = response.data
        }, (error) => {
          console.log(error)
        }).catch((error) => {
          this.$notify(
            { type: 'error', text: error.message }
          )
        })
    },
    getStates () {
      this.$http.get('plg/selected-states-of-campaign/' + this.$route.params.CampaignId)
        .then((response) => {
          console.log(response.data)
          this.getSelStates = response.data
        }, (error) => {
          console.log(error)
        }).catch((error) => {
          this.$notify(
            { type: 'error', text: error.message }
          )
        })
    },
    getCampaignView () {
      this.$http.get('plg/get-campaign-reviewer-details/' + this.$route.params.CampaignId)
        .then((response) => {
          console.log(response.data)
          this.getCampaignDetail = response.data
          if (this.getCampaignDetail.geo_location_type !== 'any-physical-location') {
            this.getMedia()
          }
        }, (error) => {
          console.log(error)
        }).catch((error) => {
          this.$notify(
            { type: 'error', text: error.message }
          )
        })
    },
    getMedia () {
      this.$http.get('plg/campaign-media-detail/' + this.$route.params.CampaignId)
        .then((response) => {
          console.log(response.data)
          this.media = response.data
          if (!this.watchVideoId) {
            this.videoId = this.extractVideoId(this.media.video_url)
          }
          console.log(this.videoId)
        }, (error) => {
          console.log(error)
        }).catch((error) => {
          this.$notify(
            { type: 'error', text: error.message }
          )
        })
    },
    getBrandDetails () {
      this.$store
        .dispatch('getBrandDetails', {
          brand_id: this.brandId
        })
        .then((response) => {
          this.brandInfo = response.response.data
          console.log(this.brandInfo)
        })
        .catch(() => {})
    },
    extractVideoId (url) {
      if (!url) return null
      const regex = /(?:youtube\.com\/(?:[^/\n\s]+\/\S+\/|(?:v|e(?:mbed)?|shorts)\/|.*[?&]v=)|youtu\.be\/)([\w-]{11})/
      const match = url.match(regex)
      return match ? match[1] : null
    },
    getProductTaskDetails () {
      this.$http.get('plg/campaign-product-task-detail/' + this.$route.params.CampaignId)
        .then((response) => {
          console.log(response.data)
          this.getProductDetail = response.data.productDetails
          this.getTasks = response.data.tasks
          this.getImages = response.data.images
        }, (error) => {
          console.log(error)
        }).catch((error) => {
          this.$notify(
            { type: 'error', text: error.message }
          )
        })
    },
    getMixCampaignActivityDetails () {
      this.$http.get('plg/mix-campaign-activity-detail/' + this.$route.params.CampaignId)
        .then((response) => {
          const data = response.data
          this.mixTasks = this.normalizeMixTasks(data)
          this.setWatchVideoFromActivities(this.mixTasks)
          this.setProductFromActivities(this.mixTasks)
          this.setPhotoFromActivities(this.mixTasks)
          this.setSurveyFromActivities(this.mixTasks)
        }, (error) => {
          console.log(error)
          this.resetMixActivityState()
        }).catch((error) => {
          console.log(error)
          this.resetMixActivityState()
        })
    },
    resetMixActivityState () {
      this.mixTasks = []
      this.watchActivity = null
      this.watchVideoId = ''
      this.productActivity = null
      this.mixProductDetail = null
      this.photoActivity = null
      this.surveyActivity = null
    },
    normalizeMixTasks (data) {
      if (!data) return []
      let activities = []
      if (Array.isArray(data.activities)) {
        activities = data.activities
      } else if (Array.isArray(data)) {
        activities = data
      }
      return activities.slice().sort((a, b) => (a.order || 0) - (b.order || 0))
    },
    setWatchVideoFromActivities (activities) {
      const watch = (activities || []).find((activity) => activity.activity_type === 'watch')
      if (watch) {
        this.watchActivity = watch
        const websiteLink = watch.link && watch.link.website_link
        this.watchVideoId = websiteLink ? (this.extractVideoId(websiteLink) || '') : ''
      } else {
        this.watchActivity = null
        this.watchVideoId = ''
      }
    },
    setProductFromActivities (activities) {
      const product = (activities || []).find((activity) => activity.activity_type === 'product')
      this.productActivity = product || null
      if (product && Array.isArray(product.products) && product.products.length) {
        const firstProduct = product.products[0]
        this.mixProductDetail = {
          name: firstProduct.name || product.activity_label || 'Product Activity',
          description: firstProduct.description || product.description || '',
          img: firstProduct.img || ''
        }
      } else if (product && Array.isArray(product.tasks) && product.tasks.length) {
        const firstTask = product.tasks[0]
        this.mixProductDetail = {
          name: product.activity_label || 'Product Activity',
          description: product.description || '',
          img: firstTask.img || ''
        }
      } else if (product) {
        this.mixProductDetail = {
          name: product.activity_label || 'Product Activity',
          description: product.description || '',
          img: ''
        }
      } else {
        this.mixProductDetail = null
      }
    },
    setPhotoFromActivities (activities) {
      this.photoActivity = (activities || []).find((activity) => activity.activity_type === 'photo') || null
      // If no product activity, use photo activity for product preview details
      if (!this.productActivity && this.photoActivity) {
        const firstTask = (this.photoActivity.tasks || [])[0]
        this.mixProductDetail = {
          name: this.photoActivity.activity_label || 'Photo Activity',
          description: this.photoActivity.description || '',
          img: firstTask && firstTask.img ? firstTask.img : ''
        }
      }
    },
    setSurveyFromActivities (activities) {
      this.surveyActivity = (activities || []).find((activity) => activity.activity_type === 'survey') || null
    },
    getSurveyAnswers (question) {
      if (!question) return []
      if (Array.isArray(question.answer)) return question.answer
      if (Array.isArray(question.answers)) return question.answers
      if (Array.isArray(question.options)) return question.options
      return []
    },
    getTaskDisplayName (task) {
      if (!task) return ''
      if (typeof task === 'string') return task
      return task.activity_label || task.name || task.task_name || task.label || task.title || ''
    }
  }

}
</script>
<style>
.ready-to-launch h2 {
    text-align: center;
    color: #782B55;
    margin-top: 35px;
    margin-bottom: 30px;
    font-weight: 700;
}
/* .ready-to-launch p{
    text-align: center;
    font-size: 17px;
    margin-bottom: 30px;
} */
.campaign-overview {
    background: #F9F9F9;
    border: 1px solid #000;
    padding: 15px 30px;
    border-radius: 8px;
}
.campaign-overview h3{
    color: #000;
    font-size: 22px;
    margin-top: 10px;
    font-weight: 600;
}
.ready-to-launch .preview{
    background: url("/../img/Home_Screen_Widgets.png");
    background-size: 100%;
    background-repeat: no-repeat;
    width: 100%;
    min-height: 620px;
    max-width: 305px;
    margin: 0 auto;
    position: relative;
}
.ready-to-launch .brand_head {
    text-align: center;
    margin-top: 50px;
    position: absolute;
    width: 82%;
    margin-left: 9%;
    padding: 7px;
    color: #000;
    font-size: 14px;
    font-weight: 500;
    line-height: 18px;
}
.ready-to-launch .brand_head img {
    position: absolute;
    left: 12px;
    top: 19px;
    width: 8px;
}
/* .ready-to-launch .store_brand {
    position: absolute;
    width: 82%;
    left: 9%;
    top: 98px;
    border-top: 1px solid #DEF2E6;
    padding-top: 3px;
} */
 .store_brand {
    margin-left: 9%;
    width: 82%;
    padding-top: 50px;
}
.ready-to-launch .brand_header img {
    width: 52px;
    float: left;
    margin-right: 5px;
}
.ready-to-launch .brand_header h6 {
    font-family: "Roboto", sans-serif;
    color: #782B55;
    font-size: 14px;
    margin-left: 5px;
    margin-top: 3px;
    margin-bottom: 5px;
}
.left_brand, .right_brand {
    width: 35px;
    max-height: 40px;
}
.ready-to-launch .task_bar {
    width: 82%;
    position: absolute;
    bottom: 40px;
    left: 9%;
}
.brand_desc p {
    font-size: 13px;
    padding-left: 10px;
    margin-top: 10px;
}
.ready-to-launch .start_pickl {
    position: absolute;
    bottom: 20px;
    margin: 0 auto;
    left: 0;
    right: 0;
    max-width: 100%;
}
.ready-to-launch .store_brand h6 {
    text-align: center;
    font-size: 14px;
    font-family: Roboto, sans-serif;
    font-weight: 500;
    line-height: 23px;
    margin-top: 5px;
    width: 180px;
    float: left;
}
.ready-to-launch .right_brand {
    position: absolute;
    right: 0px;
    width: 35px;
    max-height: 40px;
    top: 3px;
}
.ready-to-launch .brand_intro ul li {
    color: #631C3C;
    font-size: 13px;
    margin-bottom: 15px;
    padding-left: 30px;
    position: relative;
    line-height: 16px;
}
.ready-to-launch .brand_desc li:after{
    content: "";
    position: absolute;
    z-index: 1;
    left: 5px;
    width: 20px;
    height: 20px;
    background: url("/../img/check.png");
    background-size: 100%;
}
.campaign-overview-list h4{
    color: #000;
    font-size: 17px;
    font-family: "Roboto", sans-serif;
    margin-top: 20px;
    margin-bottom: 5px;
    font-weight: 600;
}
.campaign-overview-list h6{
    color: #000;
    font-size: 14px;
    font-family: "Roboto", sans-serif;
    margin-bottom: 30px;
}
.campaign-overview-list h4 span{
    font-size: 16px;
    font-weight: 400;
}
.ready-to-launch {
    margin-bottom: 30px;
}
.brand_head {
    text-align: center;
    margin-top: 65px;
    position: absolute;
    width: 82%;
    box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.3);
    margin-left: 9%;
    padding: 7px;
    color: #000;
    font-size: 15px;
}
/* .brand_intro {
    height: 280px;
    background: #FBF0E8;
    width: 82%;
    position: absolute;
    left: 9%;
    top: 266px !important;
} */
.scrolled-fix{
    position: fixed !important;
    top: 25px;
    right: 50px;

}
.newPrev {
    background: url("/../img/newMobBack.png") !important;
    background-size: 100% !important;
    background-repeat: no-repeat !important;
    height: 630px !important;
    max-width: 305px !important;
    overflow: hidden;
}
.logoHeadBox {
    text-align: center;
    margin-top: 65px;
    display: inline-block;
    width: 100%;
}
.newPrevLogo {
    width: 90px;
    margin: 0 auto;
    background: #fff;
    height: 90px;
    border-radius: 100%;
    padding: 10px;
}
.newPrevHead {
    color: #000;
    font-family: "Roboto", sans-serif;
    font-size: 16px;
    font-weight: 500;
}
.yourVideo {
    width: 90%;
    margin-left: 5%;
    margin-top: 20px;
}
.mediaName{
    width: 80%;
    margin-left: 10%;
    margin-top: 20px;
    border-bottom: 1px solid #D5DAD8;
    padding-bottom: 35px;
}
.mediaDesc {
    width: 80%;
    margin-left: 10%;
    margin-top: 20px;
}
.mediaName h4,
.mediaDesc h4{
    font-size: 16px;
    color: #000;
    font-family: "Roboto", sans-serif;
}
.mediaName h6{
    font-weight: normal;
    color: #000;
    font-size: 14px;
    font-family: "Roboto", sans-serif;
}
.mediaDesc p{
    font-size: 13px;
    overflow: hidden;
}
.NewPrevAct .brand_intro {
    min-height: 325px;
    width: 88%;
    float: left;
    margin-left: 6%;
    border-top: 1px solid #B1B5B3;
    padding-top: 4px;
}
.NewPrevAct .brand_header {
    width: 96%;
    margin-left: 2%;
}
.NewPrevAct .brand_header img {
    width: 60px;
    float: left;
    margin-right: 5px;
    border: 1px solid #000;
    padding: 3px;
    min-height: 60px;
}
.mapBox h5{
    color: #000;
    font-size: 15px;
    padding-top: 10px;
}
.mapBox {
    float: left;
    width: 88%;
    margin-left: 6%;
    text-align: center;
    background: #F9FFFC;
    border-top: 1px solid #D5DAD8;
    margin-top: 5px;
}
.ready-to-launch .nav-tabs>li>a{
    font-size: 17px;
    margin-right: 25px;
}
.ready-to-launch .nav-tabs li:last-child a{
    margin-right: 0px !important;
}
#audience-overview .slider {
    position: absolute;
    cursor: pointer;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: #ccc;
    transition: .4s;
    border-radius: 34px;
}
#audience-overview .switch {
    display: inline-block;
    width: 55px !important;
    height: 30px;
    margin-top: 0 !important;
    position: absolute !important;
    right: 0;
    top: 35px;
}
input:checked+.slider {
    background-color: #75f94c !important;
}
input:checked+.slider:before {
    transform: translateX(26px);
}
.slider:before {
    position: absolute;
    content: "";
    height: 21px;
    width: 21px;
    left: 4px;
    bottom: 4px;
    background-color: #fff;
    transition: .4s;
    border-radius: 50%;
}
#audience-overview .switch input{
    display: none;
}
.mixTaskList {
    width: 80%;
    margin-left: 10%;
    margin-top: 12px;
    max-height: 160px;
    overflow: hidden;
}
.mixTaskList h4 {
    font-size: 16px;
    color: #000;
    font-family: "Roboto", sans-serif;
    margin-bottom: 8px;
}
.mixTaskList ul {
    list-style: none;
    padding-left: 6px;
    margin: 0;
}
.mixTaskList ul li {
    color: #631C3C;
    font-size: 13px;
    margin-bottom: 8px;
    padding-left: 30px;
    position: relative;
    line-height: 16px;
}
.mixTaskList ul li:after {
    content: "";
    position: absolute;
    z-index: 1;
    left: 5px;
    width: 20px;
    height: 20px;
    background: url("/../img/check.png");
    background-size: 100%;
}
</style>
